import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "state";
import { Provider } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";
import axios from 'axios'
axios.defaults.baseURL = 'https://node.app.paluzapp.a2hosted.com/api';
axios.interceptors.request.use(
  (config) => {
    const storedToken = localStorage.getItem("token");

    if (storedToken) {
      try {
        const parsedToken = JSON.parse(storedToken);
        const token = parsedToken?.idToken;

        if (token) {
          if (typeof config.headers?.set === "function") {
            config.headers.set("Authorization", `Bearer ${token}`);
            config.headers.set("x-access-token", token);
          } else {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
            config.headers["x-access-token"] = token;
          }
        }
      } catch (error) {
        return config;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode> 
);
